/**
 * Determines the appropriate price label based on vehicle make and type.
 *
 * Uses internal configuration to determine which label to use for each make/type combination.
 * Falls back to MSRP for any make/type not found in the configuration.
 *
 * @param {Object} params - Parameters object
 * @param {string} params.makeCode - The vehicle's make code (e.g., 'TOYOTA', 'FORD')
 * @param {string} params.type - The vehicle type (e.g., 'New', 'Used', 'Certified')
 * @returns {string} The appropriate price label (e.g., 'TSRP', 'MSRP', 'LSRP', etc.)
 *
 * @example
 * getPriceLabel({ makeCode: 'TOYOTA', type: 'New' })
 * // returns 'TSRP'
 *
 * @example
 * getPriceLabel({ makeCode: 'TOYOTA', type: 'Used' })
 * // returns 'MSRP'
 *
 * @example
 * getPriceLabel({ makeCode: 'FORD', type: 'New' })
 * // returns 'MSRP'
 */

// Internal configuration mapping makes to their labels and applicable types
const MAKE_LABEL_CONFIG = {
    TOYOTA: { label: 'TSRP', types: ['New'], description: 'Total Suggested Retail Price' },
    // Add other makes as needed:
    // LEXUS: { label: 'LSRP', types: ['New', 'Certified'] },
    // SCION: { label: 'SSRP', types: ['New'] },
};

export default function getPriceLabel({ makeCode, type } = {}) {
    // Check if make exists in configuration
    if (makeCode && MAKE_LABEL_CONFIG[makeCode]) {
        const makeConfig = MAKE_LABEL_CONFIG[makeCode];
        const isValidType = makeConfig?.types?.includes(type);
        return isValidType ? makeConfig.label : 'MSRP';
    }

    // Default to MSRP for any make/type not in configuration
    return 'MSRP';
}

export function getPriceDescription({ makeCode, type }) {
    if (makeCode && MAKE_LABEL_CONFIG[makeCode]) {
        const makeConfig = MAKE_LABEL_CONFIG[makeCode];
        const isValidType = makeConfig?.types?.includes(type);
        return isValidType ? makeConfig.description : '';
    }

    // Default to empty for any make/type not in configuration
    return '';
}
